import React from 'react';
import { Badge } from 'react-bootstrap';

export default function DGLTH_order_list_request({ item, entity = null }) {

    return (
        <Badge bg={item && item.finishDate ? 'success' : 'warning'}>
            {item && item.finishDate ? 'Completato' : 'In corso'}
        </Badge>
    );
}
